import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cmg-clear2-ui-shared-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class RowComponent {
  readonly label = input<string | null>(null);
  readonly value = input<string | null>(null);
  readonly isBoldLabel = input<boolean>(false);
  readonly isHTML = input<boolean>(false);
}
